import { css } from '@fable/theme'
import { useStats } from '../../lib/ctx/stats'
import { motion } from 'framer-motion'
import { ReaderSummaryHeader } from './ReaderSummaryHeader'
import { ReaderSummaryInfo } from './ReaderSummaryInfo'
import { ReaderSummaryText } from './ReaderSummaryText'
import { ReaderSummaryFeedbackButtons } from './ReaderSummaryFeedbackButtons'
import { useReaderSummary } from '../../lib/ctx/reader_summary'
import { ReaderSummaryLoader } from './ReaderSummaryLoader'

export const ReaderSummary = () => {
  const [theme, year] = useStats((s) => [s.theme, s.year])
  const [status, summary, isZeroState] = useReaderSummary((s) => [
    s.status,
    s.summary,
    s.isZeroState,
  ])

  if (status === 'loading') return <ReaderSummaryLoader />
  if (status === 'hidden') return null

  const zeroStateSummary = `Add 3 books towards your ${year} Reading Goal and we'll update your Reader Summary!`
  const text = isZeroState ? zeroStateSummary : summary

  return (
    <motion.div
      className={css`
        width: 100%;
        display: flex;
        align-items: center;
        flex-direction: column;
        gap: 8px;
        padding-top: 15px;
      `}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.4, ease: 'easeInOut' }}
    >
      <ReaderSummaryHeader />
      <ReaderSummaryInfo />
      <ReaderSummaryText color={theme.summaryText} text={text} />
      <ReaderSummaryFeedbackButtons />
    </motion.div>
  )
}
